import { reactive } from 'vue'

export const menu = reactive({
    items: [
        {
            title: 'Карточки',
            to: '/match',
            icon: 'ti-list',
            name: 'match',
            active: false
        },
        {
            title: 'Объединение ВБ',
            to: '/wb-cards',
            icon: 'ti-cards',
            name: 'wb-cards',
            active: false
        },
        {
            title: 'Поставщики',
            to: '/suppliers',
            icon: 'ti-table',
            name: 'suppliers',
            active: false
        },
        {
            title: 'Товары',
            to: '/products',
            icon: 'ti-box',
            name: 'products',
            active: false
        },
        {
            title: 'Сертификаты',
            to: '/certificates',
            icon: 'ti-certificate',
            name: 'certificates',
            active: false
        },
        {
            title: 'Правила',
            to: '/rules',
            icon: 'ti-pencil',
            name: 'rules',
            active: false
        },
        {
            title: 'Магазины',
            to: '/stores',
            icon: 'ti-brand-appgallery',
            name: 'stores',
            active: false
        },
        {
            title: 'Шаблоны',
            to: '/templates',
            icon: 'ti-template',
            name: 'templates',
            active: false
        },
        {
            title: 'Задачи',
            to: '/tasks',
            icon: 'ti-list-details',
            name: 'tasks',
            active: false
        },
    ],
    update(to){
        const active = to.name === 'certificate-detail' ? 'certificates' : to.name
        this.items.filter((item) => item.active).forEach((item) => item.active = false)
        this.items.filter((item) => item.name === active).forEach((item) => item.active = true)
        if(MobileMenu.open){
            MobileMenu.toggle()
        }
    }
})

export const MobileMenu = reactive({
    open: false,

    toggle(){
        this.open = !this.open
    }
})